import { render, staticRenderFns } from "./nbn-order-item.vue?vue&type=template&id=48fed7de&scoped=true"
import script from "./nbn-order-item.vue?vue&type=script&lang=js"
export * from "./nbn-order-item.vue?vue&type=script&lang=js"
import style0 from "./nbn-order-item.vue?vue&type=style&index=0&id=48fed7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fed7de",
  null
  
)

export default component.exports